export default {
    // --------Title--------
    taxRates: '税率',
    newTaxRate: '添加税率',
    updateTaxRate: '更新税率',
    rateName: '税率名称',
    taxPercentage: '税百分比',
    rateInfo: '税率信息',
    detailsOfTaxRateCharges: '税率收费详情',

};